<template>
  <div>
    <button
      v-if="editMode"
      type="button"
      class="btn btn-secondary"
      @click="$emit('click')"
    >
        <icon class="btn-icon" name="arrow-left" scale="0.9"/>
        Go Back
    </button>
    <button
      v-else
      type="button"
      class="btn btn-primary"
      @click="$emit('click')"
    >
        <icon class="btn-icon" name="pencil-alt" scale="0.9"/>
        Edit
    </button>

  </div>
</template>

<script>
  import 'vue-awesome/icons/pencil-alt'
  import 'vue-awesome/icons/arrow-left'

  export default {
    props: {
      editMode: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
